import { createEffect, createEvent, createStore, sample } from "effector";
import {
  userService,
  UserProfileResponse,
} from "@features/settings/service/userService";
import { AuthService, UserSettings } from "@features/auth/service/authService";
import { logoutFx } from "@features/auth/store/auth";

// Events
export const fetchUserProfile = createEvent();
export const fetchUserSettings = createEvent();
export const organizationDataChanged = createEvent();

// Effects
export const fetchUserProfileFx = createEffect<
  void,
  UserProfileResponse,
  Error
>(() => {
  return userService.getProfile();
});

export const fetchUserSettingsFx = createEffect<void, UserSettings, Error>(
  () => {
    return AuthService.getUserSettings();
  }
);

// Stores
export const $userProfile = createStore<UserProfileResponse | null>(null)
  .on(fetchUserProfileFx.doneData, (_, profile) => profile)
  .reset(logoutFx.done);

export const $userSettings = createStore<UserSettings | null>(null)
  .on(fetchUserSettingsFx.doneData, (_, settings) => settings)
  .reset(logoutFx.done);

export const $userProfileLoading = fetchUserProfileFx.pending;
export const $userSettingsLoading = fetchUserSettingsFx.pending;

export const $userProfileError = createStore<string | null>(null)
  .on(fetchUserProfileFx.failData, (_, error) => error.message)
  .reset(fetchUserProfileFx)
  .reset(logoutFx.done);

export const $userSettingsError = createStore<string | null>(null)
  .on(fetchUserSettingsFx.failData, (_, error) => error.message)
  .reset(fetchUserSettingsFx)
  .reset(logoutFx.done);

// Logic
sample({
  clock: fetchUserProfile,
  target: fetchUserProfileFx,
});

sample({
  clock: fetchUserSettings,
  target: fetchUserSettingsFx,
});
